const amount = (minor) => `${(Number(minor || 0) / 100).toLocaleString("fr-FR").replace(/[\u00a0\u202f]/g, " ")} F`;
const clean = (value) => Array.from(String(value || ""), (character) => {
  const code = character.charCodeAt(0);
  return code < 32 || code === 127 ? " " : character;
}).join("");
const reservePublicReference = (proof) => clean(
  proof?.publicReference ||
  (proof?.mode === "issue" ? proof?.paymentNumbers?.[0] : "") ||
  proof?.reserveId ||
  "",
);
const { groupPrintedReserveLines } = require('./printedItems');
function reserveReceiptLines(proof) {
  if (Array.isArray(proof?.proofs)) return proof.proofs.flatMap(reserveReceiptLines);
  if (!proof || !["issue", "redeem"].includes(proof.mode)) return [];
  return [
    "", proof.mode === "issue" ? "ARTICLES EN RESERVE" : "UTILISATION DE RESERVE",
    `Reference : ${reservePublicReference(proof)}`,
    ...(proof.mode === "issue" ? groupPrintedReserveLines(proof.lines).map((line) => `${line.quantity} x ${clean(line.label)} : ${amount(line.netMinor)}`) : []),
    `${proof.mode === "issue" ? "Valeur mise en reserve" : "Montant deja paye utilise"} : ${amount(proof.reserveMinor)}`,
    `Encaissement de ce paiement : ${amount(proof.externalMinor)}`,
    `Solde apres operation : ${amount(proof.balanceMinor)}`,
    "Montant utilisable pour d'autres articles.",
    "Les quantites aux futurs tarifs ne sont pas garanties.",
    "Conservez cette preuve pour utiliser votre reserve.",
  ];
}
function reserveReceiptHtml(proof) {
  return reserveReceiptLines(proof).map((line) => `<div>${line.replace(/[&<>"']/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character]))}</div>`).join("");
}
function buildReserveReportSummary(data) {
  const grouped = new Map();
  for (const issue of Array.isArray(data?.issues) ? data.issues : []) {
    for (const line of Array.isArray(issue?.lines) ? issue.lines : []) {
      const label = clean(line?.label || "Article").trim() || "Article";
      const current = grouped.get(label) || { label, quantity: 0, valueMinor: 0 };
      current.quantity += Number(line?.quantity || 0);
      current.valueMinor += Number(line?.valueMinor || 0);
      grouped.set(label, current);
    }
  }
  return {
    issuedMinor: Number(data?.issuedMinor || 0),
    redeemedMinor: Number(data?.redeemedMinor || 0),
    cancelledIssueMinor: Number(data?.cancelledIssueMinor || 0),
    restoredRedemptionMinor: Number(data?.restoredRedemptionMinor || 0),
    lines: Array.from(grouped.values()).sort((a, b) =>
      a.label.localeCompare(b.label, "fr"),
    ),
  };
}
function reserveReportLines(data) {
  if (!data || !(data.issuedMinor || data.redeemedMinor || data.cancelledIssueMinor || data.restoredRedemptionMinor)) return [];
  const summary = buildReserveReportSummary(data);
  const lines = [];
  if (summary.issuedMinor || summary.cancelledIssueMinor) {
    lines.push("CONSIGNATIONS");
    for (const item of summary.lines) {
      lines.push(`${item.quantity}x ${item.label} : ${amount(item.valueMinor)}`);
    }
    lines.push(`Total : ${amount(summary.issuedMinor)}`);
    if (summary.cancelledIssueMinor) lines.push(`Mises en reserve annulees : ${amount(summary.cancelledIssueMinor)}`);
  }
  if (summary.redeemedMinor || summary.restoredRedemptionMinor) {
    if (lines.length) lines.push("");
    lines.push("RESERVES UTILISEES");
    lines.push(`Total : ${amount(summary.redeemedMinor)}`);
    if (summary.restoredRedemptionMinor) lines.push(`Montants recredites apres annulation : ${amount(summary.restoredRedemptionMinor)}`);
  }
  return lines;
}
module.exports = { reservePublicReference, reserveReceiptLines, reserveReceiptHtml, buildReserveReportSummary, reserveReportLines };
